import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <div className='footer'>
        <h5>© Budget Assit</h5>

    </div>
  )
}

export default Footer